import script from "./LogView.vue?vue&type=script&setup=true&lang=js"
export * from "./LogView.vue?vue&type=script&setup=true&lang=js"

import "./LogView.vue?vue&type=style&index=0&id=4feff0f2&scoped=true&lang=css"

import exportComponent from "D:\\Github\\SmsAdminOnlineApplication\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4feff0f2"]])

export default __exports__